import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { getProfile, profileSelector } from '../feature';

export const useGetProfile = () => {
  const dispatch = useAppDispatch();

  const data = useAppState(profileSelector);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  return data;
};
